import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { useState } from "react";

export default function Refund() {
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (id) => {
    setExpandedSections(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const sections = [
    {
      id: 1,
      title: "General Refund Policy",
      icon: "🛡️",
      content: "At Shreeji Surti Swad, customer satisfaction is our top priority. We maintain transparent and fair refund practices to ensure your trust in our service. If you're not entirely satisfied with your order, our dedicated support team is ready to assist you."
    },
    {
      id: 2,
      title: "Refund Eligibility",
      icon: "✅",
      content: "Refunds will be processed for:",
      items: [
        "Items received spoiled, damaged, stale, or incorrect",
        "Quality of food significantly below our standards",
        "Duplicate payment processing for same order"
      ]
    },
    {
      id: 3,
      title: "Non-Refundable Items",
      icon: "❌",
      content: "The following are generally non-refundable:",
      items: [
        "Items that were consumed or partially consumed",
        "Orders cancelled after preparation has started",
        "Delivery charges (unless order was never delivered)",
        "Promotional discounts applied incorrectly by customer",
        "Service charges for completed orders"
      ]
    },
    {
      id: 4,
      title: "How to Initiate a Refund",
      icon: "📝",
      content: "To request a refund, contact our support team within 24 hours:",
      items: [
        "Provide your Order ID (found in emails & Order History)",
        "Describe the issue in detail with exact item names",
        "Upload photos/videos as evidence if applicable",
        "Include your preferred resolution (refund/replacement)",
        "Expected response time: 2-4 hours during business hours"
      ]
    },
    {
      id: 5,
      title: "Refund Processing Timeline",
      icon: "⏱️",
      content: "Our refund process is fast and transparent:",
      items: [
        "Support Review: 2-4 hours (within business hours)",
        "Approval/Rejection: Within 24 hours",
        "Refund Processing: 5-7 business days",
        "Bank Credit: 3-5 business days after processing",
        "During peak hours or weekends, may take slightly longer"
      ]
    },
    {
      id: 6,
      title: "Partial Refunds",
      icon: "💰",
      content: "We offer partial refunds for:",
      items: [
        "Missing individual items from order",
        "Partial delivery (e.g., received 3 of 4 ordered items)",
        "Poor quality food items but order otherwise acceptable",
        "Cold/improperly packaged food on delivery"
      ]
    },
    {
      id: 7,
      title: "Alternative Solutions",
      icon: "🔄",
      content: "If refund is not your preference:",
      items: [
        "Coupon Credit: Approved compensation is issued as coupon credit for next order",
        "Mixed Resolution: Partial refund + coupon credit",
        "All alternatives available depending on issue type",
        "Customer gets to choose preferred resolution"
      ]
    },
    {
      id: 8,
      title: "Contact & Dispute Resolution",
      icon: "📞",
      content: "Issues or disputes? We're here to help:"
    }
  ];

  return (
    <div className="home">
      <Navbar />

      <div className="customer-page">
        {/* HERO SECTION */}
        <div className="refund-hero">
          <h1>Refund & Return Policy</h1>
          <p>We believe in transparency and customer satisfaction</p>
          <div className="refund-stats">
            <div className="stat">
              <strong>24h</strong><span>Support</span>
            </div>
            <div className="stat">
              <strong>5-7d</strong><span>Processing</span>
            </div>
            <div className="stat">
              <strong>100%</strong><span>Transparent</span>
            </div>
          </div>
        </div>

        {/* LAST UPDATED */}
        <div className="customer-page-header" style={{ marginBottom: "30px" }}>
          <p>Last Updated: March 2026 • Policy applies to all orders placed through our platform</p>
        </div>

        {/* EXPANDABLE SECTIONS */}
        <div className="refund-sections">
          {sections.map(section => (
            <div key={section.id} className="refund-card">
              <div
                className="refund-card-header"
                onClick={() => toggleSection(section.id)}
              >
                <div className="refund-card-title">
                  <span className="refund-icon">{section.icon}</span>
                  <h3>{section.title}</h3>
                </div>
                <button className={`expand-btn ${expandedSections[section.id] ? 'open' : ''}`}>
                  ▼
                </button>
              </div>

              {expandedSections[section.id] && (
                <div className="refund-card-content">
                  <p>{section.content}</p>
                  {section.items && (
                    <ul className="refund-items">
                      {section.items.map((item, idx) => (
                        <li key={idx}>
                          <span className="check">✓</span>
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
            </div>
          ))}

          {/* CONTACT CARD */}
          <div className="refund-card contact-card">
            <div className="refund-card-header">
              <div className="refund-card-title">
                <span className="refund-icon">📧</span>
                <h3>Get Support</h3>
              </div>
            </div>
            <div className="refund-card-content contact-methods">
              <div className="contact-method">
                <span>📧</span>
                <div>
                  <strong>Email</strong>
                  <p>shreejisurtiswad@gmail.com</p>
                </div>
              </div>
              <div className="contact-method">
                <span>📞</span>
                <div>
                  <strong>Phone</strong>
                  <p>+91 7977788566</p>
                </div>
              </div>
              <div className="contact-method">
                <span>💬</span>
                <div>
                  <strong>Live Chat</strong>
                  <p>Available 8 AM - 10 PM</p>
                </div>
              </div>
              <div className="contact-method">
                <span>⏰</span>
                <div>
                  <strong>Response Time</strong>
                  <p>Within 2-4 hours</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ QUICK LINKS */}
        <div className="refund-faq">
          <h3>Common Questions?</h3>
          <div className="faq-grid">
            <div className="faq-item">
              <strong>When will I get my refund?</strong>
              <p>5-7 business days after approval</p>
            </div>
            <div className="faq-item">
              <strong>If replacement is not available, what will I receive?</strong>
              <p>We provide coupon credit for your next order.</p>
            </div>
            <div className="faq-item">
              <strong>What if I'm not satisfied with the decision?</strong>
              <p>Escalate to senior support for review</p>
            </div>
            <div className="faq-item">
              <strong>Do delivery charges get refunded?</strong>
              <p>Only if order was never delivered</p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
